module.exports = __webpack_public_path__ + "img/img1.fd0ad8ef.png";